export function queueDashboardNotice(message) {
  try {
    if (!message) return;
    sessionStorage.setItem("posm_notice", String(message));
  } catch {
    // Ignore storage failures.
  }
}

export function consumeDashboardNotice() {
  try {
    const message = sessionStorage.getItem("posm_notice");
    if (message) sessionStorage.removeItem("posm_notice");
    return message || "";
  } catch {
    return "";
  }
}

export async function shareAppLink({ title = "POS Matka", text = "Join POS Matka", url = window.location.origin } = {}) {
  if (typeof window !== "undefined" && window.POSMApp?.postMessage) {
    try {
      window.POSMApp.postMessage(
        JSON.stringify({
          type: "share",
          title,
          text,
          url,
        })
      );
      return true;
    } catch {
      // Fall through to web sharing.
    }
  }

  if (navigator.share) {
    await navigator.share({ title, text, url });
    return true;
  }

  await navigator.clipboard.writeText(url);
  return false;
}

export function buildWhatsAppUrl(phone, message = "Hello POS Matka support") {
  const digits = String(phone || "").replace(/\D/g, "");
  const text = encodeURIComponent(String(message || "").trim() || "Hello POS Matka support");
  if (!digits) return "";
  return `https://api.whatsapp.com/send?phone=${digits}&text=${text}`;
}

let lastExternalOpen = { url: "", at: 0 };

function shouldSuppressDuplicateOpen(target) {
  const now = Date.now();
  if (lastExternalOpen.url === target && now - lastExternalOpen.at < 3500) {
    return true;
  }
  lastExternalOpen = { url: target, at: now };
  return false;
}

export function openExternalLink(url, fallbackUrl = "") {
  const target = String(url || "").trim();
  const fallback = String(fallbackUrl || "").trim();
  if (!target || typeof window === "undefined") return false;
  if (shouldSuppressDuplicateOpen(target)) return true;

  if (window.POSMApp?.postMessage) {
    try {
      window.POSMApp.postMessage(JSON.stringify({ type: "openExternal", url: target, fallbackUrl: fallback }));
      return true;
    } catch {
      // Fall through to browser handling.
    }
  }

  const isTouchLike = typeof navigator !== "undefined" && /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");
  if (isTouchLike) {
    if (fallback && fallback !== target) {
      const startedAt = Date.now();
      const maybeFallback = () => {
        if (document.hidden) return;
        if (Date.now() - startedAt < 650) return;
        window.location.href = fallback;
      };
      setTimeout(maybeFallback, 900);
    }
    window.location.href = target;
    return true;
  }

  try {
    const link = document.createElement("a");
    link.href = target;
    link.rel = "noopener noreferrer";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch {
    window.location.href = target;
  }
  return true;
}
